module.exports = __webpack_public_path__ + "media/images/brand/facebook_link-4266bbdfb61dfc3fb4311e44c74d496d.svg";